/**
 * Critical performance overrides (theme.liquid only – không sửa file pf-* auto-generate).
 * 1️⃣ LCP: hero .pf_trending (5 ảnh đầu); product page: first .product-gallery__image.
 * 2️⃣–3️⃣ Defer/delay: xử lý trong theme.liquid (script defer, third-party delay).
 * 4️⃣ CLS: width/height set trong product-images.liquid.
 * 5️⃣ Gallery lazyload: first image eager, còn lại lazyload trong product-images.liquid.
 * 6️⃣ Fonts: preload trong theme.liquid.
 * + Video reel: strip src, preload=none; IO → preload=metadata (lazysizes unveil).
 */
(function () {
  'use strict';

  function runCriticalPerformance() {
    try {
      // --- 1️⃣ LCP: first 5 hero product images (index/collection) ---
      var heroSelector = '.pf_trending .pf_product-list-container .pf_product-image img, .pf_trending .pf_product-list-container .pf_product-image';
      var heroNodes = document.querySelectorAll(heroSelector);
      for (var i = 0; i < heroNodes.length && i < 5; i++) {
        var img = heroNodes[i];
        if (img && img.tagName && img.tagName.toLowerCase() === 'img') {
          img.loading = 'eager';
          img.setAttribute('fetchpriority', 'high');
        }
      }

      // --- 1️⃣ LCP: product page – đảm bảo ảnh chính gallery eager + high priority ---
      var productLcp = document.querySelector('.product_gallery .product-gallery__image, .product_gallery .product-gallery__image--lcp');
      if (productLcp && productLcp.tagName && productLcp.tagName.toLowerCase() === 'img') {
        productLcp.loading = 'eager';
        productLcp.setAttribute('fetchpriority', 'high');
      }

      // --- Video reel: strip src, preload=none; IO → preload=metadata (lazysizes sets src) ---
      var reelVideos = document.querySelectorAll('video.video-reel-thumbnail.lazyload');
      function stripReelVideoSrc(video) {
        video.removeAttribute('src');
        video.preload = 'none';
        video.setAttribute('fetchpriority', 'low');
        var sources = video.querySelectorAll('source');
        for (var j = 0; j < sources.length; j++) {
          sources[j].removeAttribute('src');
        }
      }
      if (reelVideos.length && typeof IntersectionObserver !== 'undefined') {
        var reelObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var video = entry.target;
            video.preload = 'metadata';
            reelObserver.unobserve(video);
          });
        }, { rootMargin: '100px', threshold: 0.01 });
        reelVideos.forEach(function (video) {
          stripReelVideoSrc(video);
          reelObserver.observe(video);
        });
      } else {
        reelVideos.forEach(stripReelVideoSrc);
      }
    } catch (e) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('critical-performance.js error', e);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCriticalPerformance);
  } else {
    runCriticalPerformance();
  }
})();
